<template>
  <v-container>
    <v-layout row wrap mt-3>
      <v-flex xs12>
        <!-- top toolbar START -->
        <v-toolbar flat height="88px">
          <v-icon class="mr-3">mdi-ballot</v-icon>
          <v-toolbar-title>Audit Logs</v-toolbar-title>
        </v-toolbar>
        <!-- top toolbar END -->
      </v-flex>
      <v-container grid-list-xs class="grey lighten-5">
        <v-layout row wrap>
          <!-- search START -->

          <!-- type select START -->
          <v-flex xs3 class="hidden-xs-only">
              <v-select
                v-model="selectedType"
                :items="typeOptions"
                label="type"
                @change="changeType()"
              ></v-select>
          </v-flex>
          <!-- type select END -->

          <!-- action select START -->
          <v-flex xs3 class="hidden-sm-and-down">
              <v-select
                v-model="selectedAction"
                :items="selectedType === '' ? [] : actionOptions.find(x => x.type === selectedType).selectValues"
                :disabled="selectedType === ''"
                label="action"
                @change="changeAction()"
              ></v-select>
          </v-flex>
          <!-- action select END -->

          <!-- name input START -->
          <v-flex xs3 class="hidden-sm-and-down">
            <v-text-field
              v-model="search"
              label="name"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <!-- name input END -->

          <!-- clear and search buttons START -->
          <v-flex xs3 class="text-xs-right hidden-xs-only">
            <v-layout right class="mt-3">
              <v-flex d-flex>
                  <v-btn class="ml-3" 
                    text
                    @click.native="clearValues()"
                  >
                    clear
                  </v-btn>
                  <v-btn class="ml-3" tile 
                    @click.native="function(){ getAudit(); pagination.page = 1 }"
                  >
                    <v-icon>mdi-file-document-box-search-outline</v-icon>
                    Search
                  </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- clear and search buttons END -->
        
          <!-- audit table START -->
          <v-flex xs12 mt-3>
            <v-data-table
              :headers="headers"
              :items="auditValues"
              :page.sync="pagination.page"
              :items-per-page="15"
              :server-items-length="totalItems"
              :loading="loading"
              class="elevation-1"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.timestamp }}</td>
                
                <td>
                  <v-icon color="secondary" small v-if='props.item.hmd_type.toLowerCase() === "dataset"'>
                    {{ $appConfig.dataset.icon }}
                  </v-icon>
                  <v-icon color="secondary" small v-if='props.item.hmd_type.toLowerCase() === "function"'>
                    {{ $appConfig.function.icon }}
                  </v-icon>
                  <v-icon color="secondary" small v-if='props.item.hmd_type.toLowerCase() === "api"'>
                    {{ $appConfig.api.icon }}
                  </v-icon>&nbsp;{{ props.item.hmd_type }}
              </td>
                
                <td class="text-xs-center">{{ props.item.action }}</td>
                <td>{{ props.item.hmd_name }}</td>
                <td class="text-xs-center">{{ props.item.actor }}</td>
              </template>
            </v-data-table>
          </v-flex>
          <!-- audit table END -->
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import SettingsService from './services/SettingsService'

  export default {
    watch: {
      loading: function(){
        if(this.loading){
          this.getAudit()
          .then(data => {
            this.auditValues = data.results
            this.totalItems = data.count
          })
        }
      },
      'pagination.page': {
        handler () {
          this.loading = true
        }
      }
    },
    mounted: function () {
      this.getAudit()
        .then(function(data){
          this.auditValues = data.items
          this.totalItems = data.count
      })
    },
    data () {
      return {
        /*search: '',*/
        totalItems: 0,
        /*pagination_config: [20],*/
        auditValues: [],
        loading: true,
        pagination: {
          rowsPerPage: 20
        },
        headers: [
          { text: 'Time', align: 'center', sortable: false, value: 'timestamp',},
          { text: 'Type', align: 'left', sortable: false, value: 'hmd_type' },
          { text: 'Action', align: 'center', sortable: false, value: 'action' },
          { text: 'Name', align: 'center', sortable: false, value: 'hmd_name' },
          { text: 'Actor ID', align: 'center', sortable: false, value: 'actor' },
        ],
        search: '',
        selectedType: '',
        selectedAction: '',
        typeOptions: [
          {text: 'dataset', value: 'dataset'},
          {text: 'api', value: 'api'},
          {text: 'function', value: 'function'},
        ],
        actionOptions: [
          {type: 'dataset', 
          selectValues: [
            {text: 'create', value: '0'},
            {text: 'update', value: '1'},
            {text: 'delete', value: '2'},
          ]},
          {type: 'api', 
          selectValues: [
            {text: 'create', value: '0'},
            {text: 'update', value: '1'},
            {text: 'delete', value: '2'},
            {text: 'get', value: '4'},
            {text: 'post', value: '5'},
          ]},
          {type: 'function', 
          selectValues: [
            {text: 'create', value: '0'},
            {text: 'update', value: '1'},
            {text: 'delete', value: '2'},
            {text: 'get', value: '4'},
            {text: 'post', value: '5'},
          ]},
        ]
      }
    },
    methods: {
      getAudit () {
        this.loading = true
        return new Promise((resolve, reject) => {
          let t = this
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let query = page ? '?page=' + page : ''
          if(this.selectedType !== '') query += '&type=' + this.selectedType
          if(this.selectedAction !== '') query += '&action=' + this.selectedAction
          if(this.search !== '') query += '&name=' + this.search
          SettingsService.get_audit_list(query).then(function (result){
            t.auditValues = result.data.results
            t.totalItems = result.data.count
            t.loading = false
          }).catch(function (error){
            t.loading = false
          })
          const total = this.totalItems
          let items = this.auditValues
          if (rowsPerPage > 0) {
            items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
          }
        })
      },
/*      getTypeLabel(item) {
        
        let current_object = item.toLowerCase()


        if (current_object == "function") return '<v-icon color="secondary">'+this.$appConfig.function.icon+'</v-icon>'
        else if (current_object == "dataset") return this.$appConfig.dataset.icon
        else if (current_object == "api") return this.$appConfig.api.icon

        return current_object

      },*/
      changeType(){
        this.selectedAction = ''
        this.pagination.page = 1
      },
      changeAction(){
        this.pagination.page = 1
      },
      clearValues(){
        this.selectedType = ''
        this.selectedAction = ''
        this.search = ''
        this.pagination.page = 1
        this.getAudit()
      }
/*      getItems(page){
        return SettingsService.get_audit_list(page).then(function (response){
          return response.data.results
        })
      }*/
    },
  }
</script>